module.exports = __webpack_public_path__ + "img/card-bg-1.e60da78.png";